import { Box, Typography } from '@mui/material';

interface AddIntegrationChannelDrawerHeaderProps {
  title: string;
}

export const AddIntegrationChannelDrawerHeader = ({
  title,
}: AddIntegrationChannelDrawerHeaderProps) => {
  return (
    <Box py={2} px={3} borderBottom="1px solid" borderColor="divider">
      <Typography variant="h6" whiteSpace="nowrap">
        {title}
      </Typography>
    </Box>
  );
};
